import React from 'react';

const POLICIES = {
  privacy: {
    title: 'מדיניות פרטיות',
    sections: [
      ['כללי', 'מערכת זו משמשת את "אימן שירותי מחשוב" לניהול עבודות, לקוחות ויומן משימות פנימי. המערכת אינה מיועדת לשימוש הציבור.'],
      ['מידע שנאסף', 'פרטי לקוחות (שם, טלפון, מייל), רישומי עבודה ותשלומים, ומשימות יומן שהוזנו על ידי בעל העסק.'],
      ['שימוש ב-Google Calendar', 'בהרשאת המשתמש בלבד, המערכת יוצרת ומעדכנת אירועים ביומן Google של בעל העסק (משימות היומן וסיכום בוקר). המערכת קוראת אירועים מהיומן רק כדי לייבא משימות. המידע מ-Google לא נמכר, לא מועבר לצד שלישי ולא משמש לפרסום.'],
      ['אבטחה ושמירה', 'המידע נשמר בשרתים מאובטחים ונגיש רק למשתמשים מורשים. ניתן לנתק את החיבור ל-Google בכל עת מתוך המערכת או מהגדרות חשבון Google.'],
      ['יצירת קשר', 'לכל שאלה: aiman@aimanpc.com | 052-576-7555'],
    ],
  },
  terms: {
    title: 'תנאי שימוש',
    sections: [
      ['כללי', 'המערכת היא כלי פנימי של "אימן שירותי מחשוב" לניהול העסק. הגישה מותרת למשתמשים מורשים בלבד.'],
      ['אחריות', 'המשתמש אחראי לנכונות הנתונים שהוא מזין. המערכת ניתנת כפי שהיא.'],
      ['יצירת קשר', 'aiman@aimanpc.com | 052-576-7555'],
    ],
  },
};

export default function PolicyPage({ type }) {
  const policy = POLICIES[type];
  return (
    <div className="min-h-screen bg-slate-50 py-16 px-4" dir="rtl" data-testid={`policy-page-${type}`}>
      <div className="container mx-auto max-w-3xl bg-white rounded-2xl shadow p-8 md:p-12 space-y-6">
        <div>
          <p className="text-sm font-semibold text-indigo-600">אימן שירותי מחשוב</p>
          <h1 className="text-4xl font-black text-slate-900 mt-1">{policy.title}</h1>
          <p className="text-xs text-slate-400 mt-2">עודכן לאחרונה: 2026</p>
        </div>
        {policy.sections.map(([h, body]) => (
          <section key={h}>
            <h2 className="text-lg font-bold text-slate-800">{h}</h2>
            <p className="text-slate-600 leading-relaxed mt-1">{body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
